module.exports = __webpack_public_path__ + "img/7.23f0330a.png";